import MaterialCheckbox, { CheckboxProps } from '@mui/material/Checkbox';

export function Checkbox(props: CheckboxProps) {
    return (
        <MaterialCheckbox
            data-testid={'Checkbox-container'}
            {...props}
        ></MaterialCheckbox>
    );
}

export default Checkbox;
